import React, {useEffect, useState, useRef} from "react";
import {toPersianNumber} from "../utils/numberConversion";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import Question from "../components/Question";
import {useDisclosure} from "@chakra-ui/react";
import OptionsPanel from "../components/OptionsPanel";
import DownloadHandler from "../utils/downloadHandler";
import {TransformWrapper, TransformComponent} from "react-zoom-pan-pinch";
import {BiSolidFilePdf} from "react-icons/bi";
import {CiTextAlignJustify} from "react-icons/ci";
import {useDispatch} from "react-redux";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";

const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
    )}:${String(remainingSeconds).padStart(2, "0")}`;
};
const createUpdateQueue = () => {
    let queue = Promise.resolve();

    const enqueue = (operation) => {
        return new Promise((resolve, reject) => {
            queue = queue.then(() => operation().then(resolve).catch(reject));
        });
    };

    return enqueue;
};

function ExamTaker() {
    const [showPDF, setShowPDF] = useState(true);
    const [seconds, setSeconds] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [examName, setExamName] = useState("");
    const [examId, setExamId] = useState("");
    const [examed, setExamed] = useState(false);
    const [pdfLink, setpdfLink] = useState("");
    const [images, setImages] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [showQuestions, setShowQuestions] = useState(true);
    const {isOpen, onClose, onOpen} = useDisclosure();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [sendingOptions, setSendingOptions] = useState([]);
    const canvasRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const updateQueue = useRef(createUpdateQueue());
    const pendingUpdates = useRef(new Set());
    const onOptionChange = async (index, option_id, option_index) => {
        try {
            updateOption(index, option_index)
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    const updateOption = async (index, selected) => {
        // Generate a unique key for this update
        const updateKey = `${index}-${selected}-${Date.now()}`;

        // If this question is already being updated, skip
        if (pendingUpdates.current.has(index)) {
            return;
        }

        pendingUpdates.current.add(index);

        // Update sending state immediately
        setSendingOptions(prevOptions => {
            const newOptions = [...prevOptions];
            newOptions[index] = selected;
            return newOptions;
        });

        try {
            await updateQueue.current(async () => {
                const SelectedOption = selected === questions[index].selected_option ? null : selected;
                const optionId = questions[index].options[SelectedOption]?.id ?? null;

                let lastError;
                for (let attempt = 1; attempt <= 3; attempt++) {
                    try {
                        const response = await api.post("/api/exam/current/select", {
                            question_id: questions[index].id,
                            option_id: optionId,
                        });

                        if (response.data.success) {
                            // Get the latest questions state before updating
                            setQuestions(prevQuestions => {
                                // Double check if this update is still valid
                                if (prevQuestions[index].selected_option !== SelectedOption) {
                                    const updatedQuestions = [...prevQuestions];
                                    updatedQuestions[index] = {
                                        ...updatedQuestions[index],
                                        selected_option: SelectedOption,
                                    };
                                    return updatedQuestions;
                                }
                                return prevQuestions;
                            });
                            return;
                        }
                        lastError = new Error('Server returned error');
                    } catch (error) {
                        lastError = error;
                    }
                }
                throw lastError;
            });
        } catch (error) {
            toast.error(`خطایی در ثبت گزینه سوال ${toPersianNumber(index + 1)} رخ داد!`, {
                position: "bottom-right",
            });
        } finally {
            // Always clean up
            pendingUpdates.current.delete(index);
            setSendingOptions(prevOptions => {
                const newOptions = [...prevOptions];
                newOptions[index] = null;
                return newOptions;
            });
        }
    };
    useEffect(() => {
        const calculateRemainingSeconds = () => {
            const now = new Date();
            const difference = Math.floor((endDate - now) / 1000); // Difference in seconds
            setSeconds(difference > 0 ? difference : 0); // Ensure no negative time
            if (difference <= 0 && seconds !== null && endDate !== null && examed == true)
                endExam();
        };

        // Initial calculation
        calculateRemainingSeconds();

        // Update every second
        const interval = setInterval(calculateRemainingSeconds, 1000);

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [endDate]);

    const fetchData = async () => {
        try {
            const response = await api.get("/api/exam/current");
            if (!response.data.success) {
                toast.info(response.data.message, {
                    position: "bottom-right",
                });
                navigate("/panel");
                return;
            }
            const exam = response.data.data;
            setExamId(exam.id);
            setExamName(exam.name);
            setpdfLink(exam.questions_file);
            setImages(exam.images);
            setEndDate(new Date(exam.exam_end_date + ' GMT+0330'));
            setQuestions(exam.questions);
            setShowQuestions(exam.show_questions);
            setExamed(true)
            setLoading(false);
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right",
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right",
            });
        }
    };
    const endExam = async () => {
        // Show confirmation prompt
        const now = new Date()
        const difference = Math.floor((endDate - now) / 1000); // Difference in seconds
        setSeconds(difference > 0 ? difference : 0); // Ensure no negative time
        if (!(difference <= 0 && seconds !== null && endDate !== null)) {
            const isConfirmed = window.confirm("آیا از پایان آزمون مطمئن هستید؟"); // "Are you sure you want to end the exam?"

            if (!isConfirmed) {
                return; // Exit if the user cancels
            }
        }
        setLoading(true);// Start loading state

        try {
            const response = await api.get("/api/exam/current/end");
            toast.success(response.data.message, {
                position: "bottom-right",
            });
            setLoading(false);
        } catch (error) {
            setLoading(false); // Ensure loading is stopped in case of error

            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    // Handle specific error if needed
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right",
            });
        } finally {
            navigate("/panel");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading || endDate == null) return <Loader/>
    if (showQuestions)
        return (
            <>
                <div className="py-2 text-center">
                    <h3>{examName}</h3>
                    <div
                        className="d-flex flex-row justify-content-around align-items-center py-2"
                        style={{borderBottom: "3px solid #EAEAEA"}}
                    >
                        <button className="btn btn-outline-red" onClick={endExam}>
                            پایان آزمون
                        </button>
                        <div className="d-flex justify-content-between gap-1">
                            <button className="btn btn-outline-blue" onClick={onOpen}>
                                کلید آزمون
                            </button>
                            <button
                                className="btn btn-outline-blue"
                                onClick={() => {
                                    DownloadHandler(pdfLink, `${examName}.pdf`);
                                }}
                            >
                                دانلود سوالات
                            </button>
                            <button
                                className="btn btn-outline-blue"
                                onClick={() => {
                                    setShowPDF(!showPDF);
                                }}
                            >
                                {showPDF ? <CiTextAlignJustify/> : <BiSolidFilePdf/>}
                            </button>
                        </div>
                        <p className="m-0">
                            زمان باقی مانده :<span>{toPersianNumber(formatTime(seconds))}</span>
                        </p>
                    </div>
                    {showPDF ? (
                        <>
                            <div className="gallery">
                                <div className="thumbnails d-flex flex-row justify-content-around mx-2">
                                    {images.map((image, index) => (
                                        <div className="d-flex flex-column" key={index}>
                                            <img
                                                src={image}
                                                alt={`در حال بارگیری ${index + 1}`}
                                                onClick={() => setCurrentIndex(index)}
                                                className={currentIndex === index ? "active" : ""}
                                                style={{
                                                    cursor: "pointer",
                                                    width: "50px",
                                                    margin: "5px",
                                                }}
                                            />
                                            <p className="m-0">{toPersianNumber(index + 1)}</p>
                                        </div>
                                    ))}
                                </div>
                                <div className="row">
                                    <div className="image-container col-lg-9 col-12">
                                        <TransformWrapper>
                                            <TransformComponent>
                                                <img
                                                    src={images[currentIndex]}
                                                    alt={`در حال بارگیری تصویر ${currentIndex + 1}`}
                                                />
                                            </TransformComponent>
                                        </TransformWrapper>
                                    </div>
                                    <div className="col-lg-3 hide-on-mobile">
                                        <ul
                                            className="modal-options nazanin p-1"
                                            style={{
                                                borderRight: "3px solid #EAEAEA",
                                                borderTop: "3px solid #EAEAEA",
                                                borderBottom: "3px solid #EAEAEA",
                                                overflowY: "auto",
                                                height: "100vw",
                                            }}
                                        >
                                            {questions.map((question, index) => (
                                                <li
                                                    key={index}
                                                    className="d-flex flex-row justify-content-center align-items-center"
                                                >
                                                    <h4>سوال {toPersianNumber(index + 1)} : </h4>
                                                    {question.options.map((option, option_index) => (
                                                        <span
                                                            key={option_index}
                                                            className={`option counter ${
                                                                option_index === question.selected_option ? "selected" : ""
                                                            } ${sendingOptions[index] === option_index ? "sending" : ""}`}
                                                            onClick={() => {
                                                                // Prevent new clicks while sending
                                                                if (!pendingUpdates.current.has(index)) {
                                                                    updateOption(index, option_index);
                                                                }
                                                            }}
                                                        >
                                                            <div>{option_index + 1}</div>
                                                        </span>
                                                    ))}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {questions.map((question, index) => (
                                <Question
                                    text={question.question_text}
                                    id={question.id}
                                    key={index}
                                    index={index}
                                    showUnder={question.show_under}
                                    selectedOption={question.selected_option ?? null}
                                    options={question.options}
                                    setOption={updateOption}
                                    image={question.image ? `${question.image}` : null}
                                    sendingOptions={sendingOptions}
                                />
                            ))}
                        </>
                    )}
                </div>
                <OptionsPanel
                    isOpen={isOpen}
                    onClose={onClose}
                    questions={questions}
                    setOption={updateOption}
                    sendingOptions={sendingOptions}
                />
            </>
        );
    else
        return (
            <div className="d-flex flex-column h-100">
                <Navbar/>
                <ul className="modal-options">
                    {questions.map((question, index) => question !== null ? (
                        <li key={index} className="d-flex flex-row justify-content-center align-items-center">
                            <h4>سوال {toPersianNumber(index + 1)} : </h4>
                            {question.options.map((id, i) => (
                                <span key={id.id}
                                      className={
                                          `option counter
                                            ${(question.selected_option ?? null) === i ? 'selected' : ''}
                                            ${`counter ${sendingOptions[index] === i ? "sending" : ""}`}
                                         `}
                                      onClick={() => {
                                          onOptionChange(index, id.id, i)
                                      }}
                                >
                                        <div>{toPersianNumber(i + 1)}</div>
                                    </span>
                            ))}
                        </li>
                    ) : null)}
                </ul>
                <button className="btn btn-outline-red w-50 d-block mx-auto my-3 mb-5" onClick={endExam}>
                    پایان آزمون
                </button>
            </div>);
}

export default ExamTaker;
